/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const SwipeDown = (props: IconProps) => (
  <Icon {...props}>
    <path d="M3.8 12.18C3.6 11.32 3.5 10.42 3.5 9.5C3.5 6.66 4.49 4.05 6.13 2L7.2 3.07C5.82 4.85 5 7.08 5 9.5C5 10.38 5.11 11.24 5.32 12.06L6.94 10.44L8 11.5L4.5 15L1 11.5L2.06 10.44L3.8 12.18ZM13.85 11.62L11.17 6.25C10.8 5.51 9.9 5.21 9.16 5.58C8.41 5.96 8.11 6.86 8.48 7.6L13.29 17.2L10.05 18C9.72 18.09 9.46 18.33 9.35 18.66L9 19.78L15.19 22.03C15.69 22.2 16.47 22.05 16.94 21.81L22.45 19.06C23.34 18.61 23.77 17.58 23.45 16.64L22.02 12.37C21.75 11.55 20.98 11 20.12 11H15.56C15.25 11 14.94 11.07 14.67 11.21L13.85 11.62Z" />
  </Icon>
);
